<div fxLayout="row" fxFlex="100%" class="container">
    <div class="linksColumn" ngClass.lt-md="twoCol" fxLayout="column" fxFlex.gt-sm="34%" fxFlex.lt-md="50%">
      <app-link-list *ngIf="updatedToday.length > 0" [title]="'Updated Today'" [links]="updatedToday"></app-link-list>
      <app-link-list [title]="'Active Comics'" [links]="activeLinks"></app-link-list>
    </div>
    <div class="linksColumn" ngClass.lt-md="twoCol" fxLayout="column" fxFlex.gt-sm="33%" fxFlex.lt-md="50%">
      <app-link-list ngClass.gt-sm="hidden" [title]="'Bloogs'" [links]="blogs"></app-link-list>
      <app-link-list [title]="'Complete Comics'" [links]="completeLinks"></app-link-list>
      <app-link-list [title]="'Incomplete Comics'" [links]="incompleteLinks"></app-link-list>
      <app-link-list [title]="'Lost Interest'" [links]="boringLinks"></app-link-list>
    </div>
    <div class="linksColumn" fxLayout="column" fxFlex.gt-sm="33%" fxFlex.lt-md="0%" ngClass.lt-md="hidden">
      <app-link-list ngClass.lt-md="hidden" [title]="'Blogs'" [links]="blogs"></app-link-list>
    </div>
</div>
